import { erpAxios } from '.';

const getSrodstva = async () => {
  const { data } = await erpAxios.get('/srodstva');
  return data;
};

export default getSrodstva;
